const state = () => ({
  buildYourJewelMode: null,
  stepsFromStone: [{ id: "STONE", active: true, expanded: false }, { id: "SETTING", active: false, expanded: false }, { id: "CUSTOMIZE", active: false, expanded: false }],
  stepsFromSetting: [{ id: "SETTING", active: true, expanded: false }, { id: "STONE", active: false, expanded: false }, { id: "CUSTOMIZE", active: false, expanded: false }],
  selectedStones: [],
  selectedSetting: null,
  stonesNumber: null
});

// getters
const getters = {
  getBuildYourJewelMode(state) {
    return state.buildYourJewelMode;
  },
  getSelectedStones(state) {
    return state.selectedStones;
  },
  getSelectedSetting(state) {
    return state.selectedSetting;
  },
  getStonesNumber(state) {
    return state.stonesNumber;
  },
  showBuildYourJewelPrice(state) {
    return state.buildYourJewelMode && state.selectedStones.length >= (state.stonesNumber - 1)
  }
};

// actions
const actions = {
  resetBuildYourJewel({ state }) {
    state.buildYourJewelMode = null;
    state.stepsFromStone = [{ id: "STONE", active: true, expanded: false }, { id: "SETTING", active: false, expanded: false }, { id: "CUSTOMIZE", active: false, expanded: false }];
    state.stepsFromSetting = [{ id: "SETTING", active: true, expanded: false }, { id: "STONE", active: false, expanded: false }, { id: "CUSTOMIZE", active: false, expanded: false }];
    state.selectedStones = [];
    state.selectedSetting = null;
    state.stonesNumber = null;
  },
  setActiveStep: function ({ state, commit }, id) {
    let steps = [];
    if (state.buildYourJewelMode == 'STONE')
      steps = state.stepsFromStone
    else if (state.buildYourJewelMode == 'SETTING')
      steps = state.stepsFromSetting

    if (state.buildYourJewelMode == 'STONE' && id == state.buildYourJewelMode) {
      commit("setSelectedSetting", null);
    }

    if (state.buildYourJewelMode == 'SETTING' && id == state.buildYourJewelMode) {
      commit("setSelectedStones", []);
    }

    steps.forEach(element => {
      element.active = false;
    });
    steps.find(s => s.id == id).active = true;
  },
  selectStone({ state, commit, dispatch }, stone) {
    if (state.selectedStones.length < state.stonesNumber)
      commit("setSelectedStones", [...state.selectedStones, stone]);
    else
      commit("setSelectedStones", [stone]);
    if (state.buildYourJewelMode == 'STONE') {
      commit("setSelectedSetting", null);
      if (state.selectedStones.length == state.stonesNumber)
        dispatch("setActiveStep", "SETTING");
    } else if (state.buildYourJewelMode == 'SETTING') {
      if (state.selectedStones.length == state.stonesNumber)
        dispatch("setActiveStep", "CUSTOMIZE");
    }
  },
  selectSetting({ state, commit, dispatch }, setting) {
    if (state.buildYourJewelMode == 'STONE') {
      commit("setSelectedSetting", setting);
      dispatch("setActiveStep", "CUSTOMIZE")
    } else if (state.buildYourJewelMode == 'SETTING') {
      commit("setSelectedStones", []);
      commit("setSelectedSetting", setting);
      dispatch("setActiveStep", "STONE");
    }
  }
};

// mutations
const mutations = {
  setSelectedStones(state, value) {
    state.selectedStones = value;
  },
  setSelectedSetting(state, value) {
    state.selectedSetting = value;
  },
  setBuildYourJewelMode(state, value) {
    state.buildYourJewelMode = value;
  },
  setStonesNumber(state, value) {
    state.stonesNumber = value;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
